import axios from 'axios'
import { CONST_API_URL } from '../constants'
import { getUserDetails, checkLocalStorageSize } from '../util'

const preLoginInstance = axios.create({
  baseURL: CONST_API_URL
})

preLoginInstance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
preLoginInstance.defaults.headers.common.mode = 'cors'
preLoginInstance.defaults.headers.common.CompanyId = getUserDetails?.CompanyId || ''
preLoginInstance.defaults.headers.common.UserId = getUserDetails?.UserId || ''
preLoginInstance.defaults.headers.post['Content-Type'] = 'text/xml'

// 1. Initialize the worker (Syntax compatible with Vite / Webpack 5)
const apiWorker = new Worker(new URL('./api.worker.js', import.meta.url), { type: 'module' })

// 2. A helper function to handle asynchronous worker communication with unique IDs
const runInWorker = (type, payload) => {
  return new Promise((resolve, reject) => {
    const messageId = Math.random().toString(36).substring(2, 15)

    const handleMessage = (e) => {
      if (e.data.id === messageId) {
        apiWorker.removeEventListener('message', handleMessage)
        if (e.data.type === 'ERROR') {
          reject(new Error(e.data.error))
        } else {
          resolve(e.data) // Returns { type: '...', data: ... }
        }
      }
    }

    apiWorker.addEventListener('message', handleMessage)
    apiWorker.postMessage({ id: messageId, type, payload })
  })
}

const ApiPost = async (options) => {
  const { reqId, payload, resId, resType = 'object', getLatest = false, getFromLocal = true } = options
  checkLocalStorageSize()

  // --- STEP 1: Check Local Storage via Worker ---
  if (!getLatest && window.localStorage.logs && getFromLocal) {
    const rawLogs = JSON.parse(window.localStorage.getItem('logs') || '[]')

    // Pass the heavy array filtering to the worker
    const cacheResult = await runInWorker('CHECK_CACHE', { reqId, requestPayload: payload, logs: rawLogs })

    if (cacheResult.type === 'CACHE_HIT') {
      return cacheResult.data
    }
  }

  // --- STEP 2: Prepare SOAP Envelope via Worker ---
  const soapPayloadResult = await runInWorker('PREPARE_SOAP', { reqId, requestPayload: payload })
  const soapDataPayload = soapPayloadResult.data

  // --- STEP 3: Network Request (Stays on Main Thread) ---
  const axiosPost = await preLoginInstance.post('', soapDataPayload)
  const resp1 = axiosPost.request.response

  // --- STEP 4: Parse SOAP Response via Worker ---
  const parseResult = await runInWorker('PARSE_SOAP_RESPONSE', { resId, rawResponse: resp1, resType })
  const resp2 = parseResult.data

  // --- STEP 5: Save back to LocalStorage ---
  if (window.localStorage.getItem('logs') && getFromLocal && !getLatest) {
    const data1 = JSON.parse(window.localStorage.getItem('logs') || '[]')
    data1.push({ reqId, payload, response: resp2 })
    window.localStorage.setItem('logs', JSON.stringify(data1))
  }

  checkLocalStorageSize()
  return resp2
}

export { preLoginInstance, ApiPost }
